import { render, staticRenderFns } from "./shop-empty.vue?vue&type=template&id=451cd5a2"
import script from "./shop-empty.vue?vue&type=script&lang=js"
export * from "./shop-empty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports